module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 169.5b5ac9af.png";